class CalendarList extends TableList {
  /**
   * Constructs an instance of the CampaignList class.
   */
  constructor(app, container, listRow, searchInputId = 'searchTable') {
    super(app, container, listRow, searchInputId)
  }

  prepareRow(row) {
    const page = _.template(this.app.templates[this.listRow]);

    const defaults = {'count': ''};
    row = {...defaults, ...row};

    const calendarSocial = !this.app.isEmpty(row.config) && !this.app.isEmpty(row.config.social) ? _.indexBy(row.config.social, 'id') : false;
    const businessProfile = {'id': row.persona_id, 'name': this.staticPH};

    let pageData = {
      ...row,
      is_default: row.is_default === "1",
      ...{socials: calendarSocial},
      ...{businessProfile: businessProfile}
    };

    const $page = $(page(pageData));

    return $page;
  }

  async renderByBusinessProfile(id) {
    const self = this;
    const $listContainer = this.container
    $listContainer.empty();

    this.showLoader({
      id: null,
      autoBuildDay: '',
      socials: '',
      name: this.staticPH,
      is_default: '',
      businessProfile: '',
      updatePosts: true,
      date_created: '',
    }, 1);
    try {
      const response = await this.app.apis['calendar'].fetch();
      $listContainer.empty();

      let calendars = [];
      _.each(response, function (row) {
        if( parseInt(row.persona_id) === parseInt(id)) {
          calendars.push(row);
        }
      })

      if (!this.app.isEmpty(calendars)) {
        _.each(calendars, function (row) {
          row.updatePosts = true;
          let $row = self.prepareRow(row);
          $row.appendTo($listContainer);
          $row.find('.business-profile-container').remove();
        });
        $('[data-bs-toggle="tooltip"]').tooltip()

      } else {
        const noRecordsOptions = {
          title: 'No Calendars Found',
          description: '',
        };
        const placeholder = new NoRecordsPlaceholder(this.app, this.container, noRecordsOptions);
        placeholder.render();
      }
    } catch (error) {
      console.error("Error occurred during operation:", error);
    }
  }

  async renderList() {
    const self = this;
    const $listContainer = this.container
    $listContainer.empty();

    this.showLoader({
      id: null,
      autoBuildDay: this.staticPH,
      socials: this.staticPH,
      name: this.staticPH,
      is_default: '',
      businessProfile: '',
      date_created: this.staticPH,
    });

    try {
      const response = await this.app.apis['calendar'].fetch();
      $listContainer.empty();

      if (!this.app.isEmpty(response)) {
        _.each(response, function (row) {
          let $row = self.prepareRow(row);
          $row.appendTo($listContainer);
        });
        $('[data-bs-toggle="tooltip"]').tooltip()

        // Set Business Profile name
        let businessProfiles = await this.app.apis['business_profile'].list();
        businessProfiles = businessProfiles.data;
        businessProfiles = _.indexBy(businessProfiles, 'id');
        $('a.business-profile-link', $listContainer).each(function () {
          const $this = $(this);
          $this.text(businessProfiles[$this.data('id')].name);
        })
      } else {
        const noRecordsOptions = {
          title: 'No Calendars Found',
          description: 'You can start creating a new calendar by clicking the button below',
          addButton: {
            text: 'Add New',
            onClick: () => {
              console.log('Add New clicked');
              // Code to open add new record form or modal
            }
          },
          help: {
            text: 'Need Help ?',
            onClick: () => {
              console.log('Help clicked');
              // Code to open help documentation or contact support
            }
          }
        };

        const placeholder = new NoRecordsPlaceholder(this.app, this.container.closest('.card'), noRecordsOptions);
        placeholder.render();
      }
    } catch (error) {
      console.error("Error occurred during operation:", error);
    }
  }
}